import React, { useEffect, useState } from "react";
import axios from "axios";
import userAuthenticationConfig from "../../../utils/userAuthenticationConfig";
import Notification from "../../elements/notification/Notification";
import { useHistory } from "react-router-dom";
import { checkFilterItem, fetchFilterData } from "../../../utils/fetchFilterData";
import { Helmet } from "react-helmet-async";
import ItemsPerPageSelect from "../../elements/filter/ItemsPerPageSelect";
import SupportUserList from "./SupportUserList";
import SupportUserFilter from "./SupportUserFilter";
import FilterAppliedList from "../../elements/filter/FilterAppliedList";
import SupportUserForm from "./SupportUserForm";
import { ROLES } from "../../../utils/consts";
import { useTranslation } from "react-i18next";

import MaterialPagination from "../../styles/materialPagination";
import { StyledContentWrapper } from "../../styles/styledMain";
import { StyledSupportUserWrapper } from "../styledSupportUser";
import { itemsPerPageValue } from "../../../utils/ItemsPerPageValue";

const SupportUserContainer = () => {
  const { t } = useTranslation("supportUserPage");
  const [supportUsers, setSupportUsers] = useState(null);
  const [totalPageCount, setTotalPageCount] = useState(null);
  const [fetch, setFetch] = useState(false);

  const history = useHistory();

  const [filterData, setFilterData] = useState({
    "page": checkFilterItem(history, "page", 1, true),
    "itemsPerPage": checkFilterItem(history, "itemsPerPage", itemsPerPageValue(), true),
    "firstname": checkFilterItem(history, "firstname", null),
    "lastname": checkFilterItem(history, "lastname", null),
    "email": checkFilterItem(history, "email", null)
  });

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  const fetchSupportUsers = () => {
    let filterUrl = fetchFilterData(filterData);
    history.replace(filterUrl);

    axios.get("/api/users" + filterUrl + "&roles=" + ROLES.ROLE_SUPPORT, userAuthenticationConfig()).then(response => {
      if (response.status === 200) {
        setSupportUsers(response.data["hydra:member"]);
        setTotalPageCount(response.data["hydra:totalPageCount"]);
      }
    }).catch(error => {
      setNotification({ ...notification, visible: true, type: "error", message: error.response.data.message });
    });
  };

  useEffect(() => {
    fetchSupportUsers();
  }, [filterData, fetch]);

  const onChangePage = (event, page) => {
    setFilterData({ ...filterData, page: page });
  };

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <StyledContentWrapper>
        <Helmet>
          <title>{t("meta.title")}</title>
        </Helmet>
        <StyledSupportUserWrapper>
          <div className="support-user-head">
            <SupportUserFilter
              filterData={filterData}
              setFilterData={setFilterData}
            />
            <ItemsPerPageSelect
              itemsPerPage={filterData.itemsPerPage}
              setItemsPerPage={(data) => setFilterData({
                ...filterData,
                "itemsPerPage": data,
                page: 1
              })}
            />
            <SupportUserForm
              notification={notification}
              setNotification={setNotification}
              setFetch={setFetch}
            />
          </div>
          <FilterAppliedList
            filterData={filterData}
            setFilterData={setFilterData}
          />
          <SupportUserList
            supportUsers={supportUsers}
          />
          {totalPageCount > 0 &&
            <MaterialPagination
              count={totalPageCount}
              shape="rounded"
              page={filterData.page}
              onChange={(event, page) => onChangePage(event, page)}
            />}
        </StyledSupportUserWrapper>
      </StyledContentWrapper>
    </>
  );
};

export default SupportUserContainer;